import { GeoMeasure } from "./geo-measure"
import { toWgs84 } from "./projection"

const solveNormalEquations = (matrix: number[][], rightHandSide: number[]) => {
    const rows = matrix.map((row, index) => [...row, rightHandSide[index]])

    for (let column = 0; column < 3; column++) {
        let pivot = column
        for (let row = column + 1; row < 3; row++) {
            if (Math.abs(rows[row][column]) > Math.abs(rows[pivot][column])) pivot = row
        }
        ;[rows[column], rows[pivot]] = [rows[pivot], rows[column]]

        for (let row = 0; row < 3; row++) {
            if (row === column) continue
            const factor = rows[row][column] / rows[column][column]
            for (let term = column; term < 4; term++) rows[row][term] -= factor * rows[column][term]
        }
    }
    return [rows[0][3] / rows[0][0], rows[1][3] / rows[1][1], rows[2][3] / rows[2][2]]
}

const fitAffine = (controlPoints: GeoMeasure["controlPoints"]) => {
    const normal = [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0],
    ]
    const eastings = [0, 0, 0]
    const northings = [0, 0, 0]

    for (const point of controlPoints) {
        const row = [point.pageX, point.pageY, 1]
        for (let a = 0; a < 3; a++) {
            for (let b = 0; b < 3; b++) normal[a][b] += row[a] * row[b]
            eastings[a] += row[a] * point.easting
            northings[a] += row[a] * point.northing
        }
    }

    const [eastPerX, eastPerY, eastOffset] = solveNormalEquations(normal, eastings)
    const [northPerX, northPerY, northOffset] = solveNormalEquations(normal, northings)

    return ([x, y]: [number, number]) => [
        eastPerX * x + eastPerY * y + eastOffset,
        northPerX * x + northPerY * y + northOffset,
    ]
}

export const projectPageCorners = (measure: GeoMeasure) => {
    const pageToProjected = fitAffine(measure.controlPoints)
    const [minX, minY, maxX, maxY] = measure.renderedBox
    const fromTopLeft: [number, number][] = [
        [minX, maxY],
        [minX, minY],
        [maxX, minY],
        [maxX, maxY],
    ]
    const turns = measure.quarterTurnsClockwise
    const rotated = [...fromTopLeft.slice(turns), ...fromTopLeft.slice(0, turns)]

    return rotated.map((corner) => {
        const [longitude, latitude] = toWgs84(measure.projection, pageToProjected(corner))
        return { latitude, longitude }
    })
}
